import * as React from "react";
import { Dropdown, IDropdownOption, Icon, Dialog, DialogFooter, TextField, PrimaryButton, DefaultButton } from "office-ui-fabric-react/lib";
import { FieldValueDropdown } from "typings";
import { BaseFieldEditor } from "../helper";
import TranslationDialog from "./TranslationDialog";
import { RootState } from "~/state";
import { connect } from "react-redux";
import { getFieldValues } from "~/state/action";
import { loadFieldValues } from "~/state/field/action";
import styled from "styled-components";
import * as G from "~/components/global.style";
export interface Props extends BaseFieldEditor
{
    value: FieldValueDropdown;
    placeholder?: string;
}
export interface Props
{
    
}

interface State
{
    addNewValue: boolean;
    showTranslationDialog: boolean;
}

type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: RootState, ownProps: Props) => ({
    values: getFieldValues(state, ownProps.field.name) || []
});

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
    loadFieldValues: (fieldName: string, valuesUrl: string) => dispatch(loadFieldValues(fieldName, valuesUrl))
});


class DropdownEditor extends React.Component<Props & StateProps, State>
{
    state = {
        addNewValue: false,
        showTranslationDialog: false
    };
    private newValue: string = "";
    loadFieldValue = () =>
    {
        const { value } = this.props;
        if (value && value.valuesUrl)
        {
            this.props.loadFieldValues(this.props.field.name, value.valuesUrl);
        }
    }

    componentWillMount()
    {
       this.loadFieldValue();
    }

    componentWillReceiveProps(nextProps: Props)
    {
        if (nextProps.value.value !== this.props.value.value)
        {
            this.loadFieldValue();
        }
    }

    private onChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) =>
    {
        
        const value = option ? option.key : undefined;
        if (value === "___NEWVALUE___")
        {
            this.setState({ addNewValue: true });
        }
        else
        {
            const fieldValue: FieldValueDropdown = {...this.props.value, value };
            this.props.onValueChange(fieldValue);
        }
       
    }

    private onRenderOption = (option: IDropdownOption) =>
    {
        return (
            <div className="dropdownExample-option">
              {option.data && option.data.icon && (
                <Icon style={{ marginRight: "8px" }} iconName={option.data.icon} aria-hidden="true" title={option.data.icon} />
              )}
              <span>{option.text}</span>
            </div>
          );
    }

    private updateNewValue = (event: React.FormEvent<HTMLInputElement>, value: string) => this.newValue = value;

    private onSaveNewValue = () =>
    {
        const value = this.newValue;
        const fieldValue: FieldValueDropdown = {...this.props.value, value  };
        this.props.onValueChange(fieldValue);
        this.setState({ addNewValue: false });
        
    }

    private onCloseNewValue = () => this.setState({ addNewValue: false });

    private getOptions = (): IDropdownOption[] =>
    {
        let options: IDropdownOption[] = [];
        options.push({ key: "", text: "Choose value" });
        options = options.concat(this.props.values.map(x => ( { key: x, text: x } ) ));
        options.push({ key: "___NEWVALUE___", text: "Add new value", data: { icon: "Add", } });
        return options;
    }

    toggleTranslationsDialog = () => this.setState({ showTranslationDialog: !this.state.showTranslationDialog});

    render()
    {
        const { value } = this.props;
        let translateBtn = null;
        if (this.props.field.fieldType.id === "text_locale_dropdown")
        {
            translateBtn = <div onClick={this.toggleTranslationsDialog} ><IconStyle><Icon iconName="BoxAdditionSolid" /> Add</IconStyle></div>;
        }

        return (
            <div>
                <Dropdown 
                    onRenderOption={this.onRenderOption}
                    disabled={this.props.disabled}
                    options={this.getOptions()}
                    selectedKey={value.value}
                    onChange={this.onChange}
                    dropdownWidth={250}
                />
                {translateBtn}
                {this.state.showTranslationDialog ? <TranslationDialog {... this.props} onClose={this.toggleTranslationsDialog} /> : null}
                <Dialog hidden={!this.state.addNewValue} onDismiss={this.onCloseNewValue}>
                     <TextField  onChange={this.updateNewValue}></TextField>
                    <DialogFooter>
                        <PrimaryButton onClick={this.onSaveNewValue} text="Create" />
                        <DefaultButton onClick={this.onCloseNewValue} text="Cancel" />
                    </DialogFooter>
                </Dialog>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DropdownEditor);

const IconStyle = styled.div`
    color: ${G.PrimaryColor};
    margin-top: 10px;
    font-size: 13px;
    display: flex;
    align-items: center;
    cursor: pointer;
    i{
        font-size: 18px;
        margin-right: 6px;
    }
`;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/dropdown/Dropdown.tsx